import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { COURSES } from "@/data/courseSections";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// export const DEFAULT_COURSE_NAME = "DP Python Programming";

// export function formatCourseName(courseName: string | undefined): string {
//   if (!courseName) return DEFAULT_COURSE_NAME;
//
//   // Map URL slugs to display names
//   if (courseName === "a-level-python-programming") {
//     return DEFAULT_COURSE_NAME;
//   }
//
//   // Convert kebab-case to readable format
//   return courseName.split('-').map(word =>
//     word.charAt(0).toUpperCase() + word.slice(1)
//   ).join(' ');
// }

export function getCoursePath(courseSlug: string): string {
  const course = COURSES.find((course) => course.slug === courseSlug);
  if (!course) {
    return null;
  }
  return `/course/${courseSlug}/section/${course.course[0].slug}/lesson/${course.course[0].lessons[0].slug}`;
}
